import React from 'react'
import Judul from './judul'
import { Container, Row, Col } from 'react-bootstrap'
import Tombol from 'components/componentsmall/button'
import './style.css'

export default function testimoni() {
    return (
        <div className="berberkah-testimoni">
          <Judul judul="Testimoni"/>
            <Container>
                <Row>
                    {
                        Testimoni.map((item, i) => {
                            return (
                                <Col md={4} key={i}>
                                <div className="card">
                                    <img src={item.src} alt="img-testimoni" />
                                    <div className="card-body">
                                        {item.body}
                                    </div>
                                    <div className="card-foot">
                                        <h6>{item.name}</h6>
                                        {item.foot}
                                    </div>
                                </div>
                            </Col>
                            )
                        })
                    }
                </Row>
                <div className="bantuan">
                    <Judul judul="Butuh Bantuan?"/>
                    <Tombol tombol="Hubungi Customer Service" />
                </div>
            </Container>
        </div>
    )
}

const Testimoni = [
    {src:"asset/berberkah/img-elipse.png", body:"“Di Berikhtiar saya bisa mendapatkan barang yang saya inginkan dengan harga yang murah dari marketplace lain.”", name:"Rivan", foot:"Wirausahawan"},
    {src:"asset/berberkah/img-elipse-2.png", body:"“Di Berikhtiar saya bisa mendapatkan barang yang saya inginkan dengan harga yang murah dari marketplace lain.”", name:"Rivan", foot:"Wirausahawan"},
    {src:"asset/berberkah/img-elipse-3.png", body:"“Di Berikhtiar saya bisa mendapatkan barang yang saya inginkan dengan harga yang murah dari marketplace lain.”", name:"Rivan", foot:"Wirausahawan"}
]
